// src/pages/Admin/VotePage/data/voteAdminOptions.js

export const DEFAULT_VOTE_FORM = {
  title: "",
  description: "",
  start_time: "",
  end_time: "",
  type: "vote",
  is_active: true,
  is_anonymous: true,

  /*
   * Règles liées aux clubs
   */
  one_vote_per_club: false,
  use_club_weight: false,
};

export const STATUS_FILTER_OPTIONS = [
  {
    value: "all",
    label: "Tous les statuts",
  },
  {
    value: "actif",
    label: "En cours",
  },
  {
    value: "a_venir",
    label: "À venir",
  },
  {
    value: "termine",
    label: "Terminés",
  },
  {
    value: "inactif",
    label: "Inactifs",
  },
];

export const TYPE_FILTER_OPTIONS = [
  {
    value: "all",
    label: "Votes et sondages",
  },
  {
    value: "vote",
    label: "Votes uniquement",
  },
  {
    value: "sondage",
    label: "Sondages uniquement",
  },
];

export const QUESTION_TYPE_OPTIONS = [
  {
    value: "single",
    label: "Réponse unique",
    description:
      "L’utilisateur sélectionne une seule proposition.",
  },
  {
    value: "multiple",
    label: "Réponses multiples",
    description:
      "L’utilisateur peut sélectionner plusieurs propositions.",
  },
  {
    value: "open",
    label: "Réponse libre",
    description:
      "L’utilisateur saisit une réponse textuelle.",
  },
];